module.exports = __webpack_public_path__ + "img/vdara5.d2704b65.jpg";